import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-electronic-billing-send-individual-email',
  templateUrl: './electronic-billing-send-individual-email.component.html',
  styleUrls: ['./electronic-billing-send-individual-email.component.scss']
})
export class ElectronicBillingSendIndividualEmailDialogComponent implements OnInit {
  value:any;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  emailCheck = true;

  ngOnInit(): void {
    const dto = {
      id:this.value,
      emailCopy:this.emailCheck,
    }
    this.change.emit(dto)
  }

  checkboxChange($event:any) {
    this.emailCheck = $event;
    const dto = {
      id:this.value,
      emailCopy:this.emailCheck,
    }
    this.change.emit(dto)
  }

}
